import React from "react";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";
import "./index.less";

import { Language } from "@/locales/zh_cn";
import { project, assets } from "@/config.json";
import { loadImage } from "@/utils";

interface IconItem {
  title: keyof Language;
  text: keyof Language;
  icon: string;
}

interface Props {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

@inject("session", "locale", "router")
@observer
class InfoContainer extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  state = {
    iconList: [
      {
        title: "login.Info1",
        text: "login.Info1_text",
        icon: "",
      },
      {
        title: "login.Info2",
        text: "login.Info2_text",
        icon: "",
      },
      {
        title: "login.Info3",
        text: "login.Info3_text",
        icon: "",
      },
      {
        title: "login.Info4",
        text: "login.Info4_text",
        icon: "",
      },
    ] as IconItem[],
  };

  componentDidMount() {
    assets.introduceList.forEach((img, index) => {
      loadImage(img).then((asset) => {
        const iconList = this.state.iconList.slice();
        iconList[index].icon = asset.default;
        this.setState({
          iconList,
        });
      });
    });
  }

  render() {
    const { locale } = this.props;
    const { iconList } = this.state;

    return (
      <div className={`info-container-page ${project}-bg`}>
        <div>{locale.get("login.InfoTitle")}</div>
        <div className="block-group">
          {iconList.map((item, i) => {
            return (
              <div className="list" key={i}>
                <img src={item.icon}></img>
                <div className="title">{locale.get(item.title)}</div>
                <div className="text">{locale.get(item.text)}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default InfoContainer as React.ComponentType;
